/**
 * Utility functions for working with HTML content
 */

/**
 * Checks if an HTML string contains visible text when rendered
 * @param {string} htmlString - The HTML string to check
 * @returns {boolean} - True if the HTML contains visible text, false otherwise
 */
export const hasVisibleText = (htmlString) => {
    if (!htmlString) return false;

    // Strip HTML tags, comments, and entities
    const strippedHtml = htmlString
        .replace(/<[^>]*>/g, '') // Remove HTML tags
        .replace(/<!--[\s\S]*?-->/g, '') // Remove HTML comments
        .replace(/&nbsp;/g, ' ') // Replace &nbsp; with space
        .replace(/\s+/g, ' ') // Normalize whitespace
        .trim(); // Remove leading/trailing whitespace

    // Check if there's any text content left
    return strippedHtml.length > 0;
};
